import { useEkardoMutation } from '@netfront/ekardo-content-library';

import { CREATE_RADIO_FEEDBACK_CONFIG } from './UseUpsertSummaryFeedbackConfigRadio.graphql';

const useUpsertSummaryFeedbackConfigRadio = (options) => {
  const { mutation, onCompleted, onError, token } = options ?? {};

  const [executeUpsertSummaryFeedbackConfigRadio, { loading: isLoading }] = useEkardoMutation({
    mutation: mutation ?? CREATE_RADIO_FEEDBACK_CONFIG,
    options: {
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          summaryFeedback: { addSummaryFeedbackConfigurationRadio: isCompleted },
        } = data;

        onCompleted({
          isCompleted,
        });
      },
      onError,
    },
    token,
  });

  const handleUpsertSummaryFeedbackConfigRadio = ({ variables }) => {
    executeUpsertSummaryFeedbackConfigRadio({
      variables,
    });
  };

  return {
    handleUpsertSummaryFeedbackConfigRadio,
    isLoading,
  };
};

export { useUpsertSummaryFeedbackConfigRadio };
